import * as React from 'react';
import { SectionWrapper, HeaderWrapper } from './UpdatePage_SC';
import { Accordion, AccordionItem } from '@inmoment/the-kitchen';
import { TitleText } from '../../../cookbook-ui/custom-components/TitleText/TitleText';
import { Page } from '../../../cookbook-ui/Page_SC';
import { KitchenContext } from '../../../App';
import { FetchingUpdates } from '../../../AppUtils';
import { Table } from '../../../cookbook-ui/custom-components/Table/Table';

export interface Props {}

export const UpdatePage: React.FC<Props> = () => {
  const { updates = [], isLoadingUpdates } = React.useContext(KitchenContext);

  const [openVersionsSet, setOpenVersionsSet] = React.useState<ReadonlySet<string>>(new Set());
  React.useEffect(() => {
    setOpenVersionsSet(new Set(updates.slice(0, 1).map((u) => u.version)));
  }, [updates]);

  return (
    <Page>
      <HeaderWrapper>
        <TitleText
          headerText="Updates"
          footerText={`Here you'll find descriptions of the work that's been done on The Kitchen, conveniently labeled by version, because we care. Only updates from the last year are shown.`}
          isLargeHeader
        />
        <br />
        <br />
      </HeaderWrapper>

      <SectionWrapper>
        {isLoadingUpdates ? <FetchingUpdates /> : null}

        {updates.length > 0 && (
          <Accordion>
            {updates.map((v) => (
              <AccordionItem
                key={v.version}
                title={`${v.version} (${v.date})`}
                open={openVersionsSet.has(v.version)}
                onOpenChange={({ open }) => {
                  setOpenVersionsSet((o) => {
                    const set = new Set(o);
                    if (open) {
                      set.add(v.version);
                    } else {
                      set.delete(v.version);
                    }
                    return set;
                  });
                }}
              >
                {openVersionsSet.has(v.version) &&
                  (v.tickets.length > 0 ? (
                    <Table
                      columns={['Ticket', 'Issue Type', 'Title', 'Description']}
                      rows={v.tickets.map((t) => {
                        const getJiraLink = (ticket: string) => (
                          <a referrerPolicy="no-referrer" target="_blank" href={`https://inmoment.atlassian.net/browse/${ticket}`} rel="noreferrer">
                            {ticket}
                          </a>
                        );

                        return typeof t === 'string' ? [getJiraLink(t), '-', '-', '-'] : [getJiraLink(t.jiraKey), t.type, t.title, t.description];
                      })}
                    />
                  ) : (
                    '{No tickets}'
                  ))}
              </AccordionItem>
            ))}
          </Accordion>
        )}
      </SectionWrapper>
    </Page>
  );
};
